document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-collapse-toggle]')) {
      e.target.closest('[data-collapse]').classList.toggle('is-opened')
    }
  })
})
